import axios from 'axios';
import apiConfig from '../../api.config';
import constants from '../../../constants';
import storage from '../../../storage';

export default function deleteHotelContract(contract) {
  const {
    host,
    URIs: { deleteHotelContract },
  } = apiConfig;

  const uri = `${host}${deleteHotelContract}`.replace(':hotelContractId', contract.id);

  const storedCredentials = JSON.parse(storage.get(constants.AUTH.USER_KEY));

  return axios
    .delete(uri, {
      data: {
        accessToken: storedCredentials.accessToken,
        hotelReference: 'civitfun',
      }
    })
    .then(res => {
      return res.data;
    });
}
